import { render, staticRenderFns } from "./DivisionSlidebar.vue?vue&type=template&id=1ae38af4"
import script from "./DivisionSlidebar.vue?vue&type=script&lang=js"
export * from "./DivisionSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports